// test1172
(1172 && 0);
